import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/context/AuthContext";
import { CheckCircle2, Circle, Calendar } from "lucide-react";

const MESES_CORTOS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

/**
 * Entrega D ampliación (12/10/2026) · "Presupuesto en el Dashboard" — qué
 * meses del año ya tienen presupuesto cargado (business rule
 * `presupuesto_mensual.{year}.{month}.{TOTAL|US|WT}`) y cuáles faltan, para
 * que Finanzas vea de un vistazo la cobertura pendiente sin entrar a
 * Business Review mes a mes.
 */
export default function BudgetCoverageWidget() {
  const [data, setData] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/business-review/presupuesto-cobertura`, { params: { year } })
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, [year]);

  if (!data) return null;

  const faltantes = data.meses.filter((m) => !m.total_cargado).length;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5" data-testid="budget-coverage-widget">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-bold text-gray-800 flex items-center gap-1.5">
          <Calendar size={14} className="text-[#007934]" /> Cobertura de presupuesto {year}
        </h3>
        <select value={year} onChange={(e) => setYear(Number(e.target.value))} className="text-xs border border-gray-200 rounded-lg px-2 py-1" data-testid="budget-coverage-year-select">
          {[year, year - 1].map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-6 sm:grid-cols-12 gap-1.5" data-testid="budget-coverage-months">
        {data.meses.map((m) => (
          <div key={m.month} className="flex flex-col items-center gap-0.5" data-testid={`budget-coverage-month-${m.month}`}>
            {m.total_cargado ? <CheckCircle2 size={16} className="text-emerald-500" /> : <Circle size={16} className="text-gray-300" />}
            <span className="text-[10px] text-gray-500">{MESES_CORTOS[m.month - 1]}</span>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-gray-400 mt-3">
        {faltantes === 0
          ? "Presupuesto consolidado cargado para todos los meses de este año."
          : `Faltan ${faltantes} mes${faltantes > 1 ? "es" : ""} por cargar el presupuesto consolidado — Admin → Reglas de negocio → "+ Nueva clave" (presupuesto_mensual.${year}.MM.TOTAL).`}
      </p>
    </div>
  );
}
